export default __webpack_public_path__ + "static/media/tabla_grupo_economico.7491c94d.xlsx";